import { Map } from 'immutable';
import {
    USER_CHECK_STATUS,
    USER_SIGN_OUT,
    USER_GET_CLIENT_INFO,
    USER_GET_CLIENT_DETAIL,
    USER_GET_PASSPORT_DETAIL,
    USER_GET_INFO,
    USER_GET_USER_SETTING,
    USER_SET_USER_SETTING,
    USER_UPDATE_ADMIN,
    USER_CREATE_CLIENT,
    USER_UPDATE_CLIENT,
    USER_RESET_PSW,
    USER_SET_STATUS,
    USER_GET_ROLES,
    USER_SET_INFO,
    USER_SET_PAGESIZE,
} from '../actions/user';
import { APP_RESET } from '../actions/reset';
import { createActionHandler, createAsyncActionHandler } from './creator';
const localPageSize = parseInt(localStorage.getItem('pageSize'), 10) || 20;
const initial = Map({
    isCheckingStatus: true,
    isSigningOut: false,
    isGettingInfo: false,
    isGettingSetting: false,
    isSettingSetting: false,
    isUpdatingAdmin: false,
    isUpdatingClient: false,
    isResettingPsw: false,
    isGettingRoles: false,
    isCreatingClient: false,
    setting: Map({}),
    status: {},
    userInfo: {},
    clientInfo: {},
    clientKYCInfo: {},
    passportInfo: {},
    roles: Map({}),
    pageSize: localPageSize > 100 ? 100 : localPageSize, // 每页最多100
    dialog: Map({ isOpen: false }),
});

const handlers = {
    ...createActionHandler(APP_RESET, () => initial),

    // 切换pagSize
    ...createActionHandler(USER_SET_PAGESIZE, (state: any, { payload }: Action.Sync) => {
        return state.merge({
            pageSize: payload,
        });
    }),

    /**
     * @deprecated
     * Admin更新之后同步更新status
     */
    ...createActionHandler(USER_SET_STATUS, (state: any, { payload }: Action.Sync) => {
        const status = state.get('status');
        return state.merge({
            status: { ...status, ...payload },
        });
    }),

    // 检查登录状态
    ...createAsyncActionHandler(USER_CHECK_STATUS, {
        init: (state: any) =>
            state.merge({
                isCheckingStatus: true,
            }),
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                isCheckingStatus: false,
                status: action.payload,
            }),
        failed: (state: any, action: Action.Sync) =>
            state.merge({
                isCheckingStatus: false,
                status: action.payload,
            }),
    }),

    // 退出登录
    ...createAsyncActionHandler(USER_SIGN_OUT, {
        init: (state: any) =>
            state.merge({
                isSigningOut: true,
            }),
        succeeded: (state: any) =>
            state.merge({
                isSigningOut: false,
            }),
        failed: (state: any) =>
            state.merge({
                isSigningOut: false,
            }),
    }),

    // 检查用户信息
    ...createAsyncActionHandler(USER_GET_CLIENT_INFO, {
        init: (state: any) =>
            state.merge({
                clientInfo: state.get('clientInfo'),
            }),
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                clientInfo: action.payload,
            }),
        failed: (state: any, action: Action.Sync) =>
            state.merge({
                clientInfo: action.payload,
            }),
    }),

    // 检查KYC信息
    ...createAsyncActionHandler(USER_GET_CLIENT_DETAIL, {
        init: (state: any) =>
            state.merge({
                clientKYCInfo: state.get('clientKYCInfo'),
            }),
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                clientKYCInfo: action.payload,
            }),
        failed: (state: any, action: Action.Sync) =>
            state.merge({
                clientKYCInfo: action.payload,
            }),
    }),

    // 检查通行证信息
    ...createAsyncActionHandler(USER_GET_PASSPORT_DETAIL, {
        init: (state: any) =>
            state.merge({
                passportInfo: state.get('passportInfo'),
            }),
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                passportInfo: action.payload,
            }),
        failed: (state: any, action: Action.Sync) =>
            state.merge({
                passportInfo: action.payload,
            }),
    }),

    // 获取用户信息
    ...createAsyncActionHandler(USER_GET_INFO, {
        init: (state: any) =>
            state.merge({
                isGettingInfo: true,
            }),
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                isGettingInfo: false,
                userInfo: action.payload,
            }),
        failed: (state: any) =>
            state.merge({
                isGettingInfo: false,
            }),
    }),

    // 更新用户信息
    ...createActionHandler(USER_SET_INFO, (state: any, { payload }: Action.Sync) => {
        const userInfo = state.get('userInfo');
        const status = state.get('status');
        return state.merge({
            status: { ...status, ...payload },
            userInfo: { ...userInfo, ...payload },
        });
    }),

    // 获取用户设置
    ...createAsyncActionHandler(USER_GET_USER_SETTING, {
        init: (state: any) =>
            state.merge({
                isGettingSetting: true,
            }),
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                isGettingSetting: false,
                setting: state.get('setting').merge(action.payload),
            }),
        failed: (state: any) =>
            state.merge({
                isGettingSetting: false,
            }),
    }),

    // 提交用户设置
    ...createAsyncActionHandler(USER_SET_USER_SETTING, {
        init: (state: any) =>
            state.merge({
                isSettingSetting: true,
            }),
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                isSettingSetting: false,
                setting: state.get('setting').merge(action.payload),
            }),
        failed: (state: any) =>
            state.merge({
                isSettingSetting: false,
            }),
    }),

    // 添加CRM后台账号
    ...createAsyncActionHandler(USER_CREATE_CLIENT, {
        init: (state: any) =>
            state.merge({
                isCreatingClient: true,
            }),
        succeeded: (state: any) =>
            state.merge({
                isCreatingClient: false,
            }),
        failed: (state: any) =>
            state.merge({
                isCreatingClient: false,
            }),
    }),

    // 更新管理员后台账号
    ...createAsyncActionHandler(USER_UPDATE_ADMIN, {
        init: (state: any) =>
            state.merge({
                isUpdatingAdmin: true,
            }),
        succeeded: (state: any, action: Action.Async) =>
            state.merge({
                isUpdatingAdmin: false,
                userInfo: action.payload,
            }),
        failed: (state: any) =>
            state.merge({
                isUpdatingAdmin: false,
            }),
    }),

    // 更新CRM账户资料
    ...createAsyncActionHandler(USER_UPDATE_CLIENT, {
        init: (state: any) =>
            state.merge({
                isUpdatingClient: true,
            }),
        succeeded: (state: any) =>
            state.merge({
                isUpdatingClient: false,
            }),
        failed: (state: any) =>
            state.merge({
                isUpdatingClient: false,
            }),
    }),

    // 重置CRM账户密码
    ...createAsyncActionHandler(USER_RESET_PSW, {
        init: (state: any) =>
            state.merge({
                isResettingPsw: true,
            }),
        succeeded: (state: any) =>
            state.merge({
                isResettingPsw: false,
            }),
        failed: (state: any) =>
            state.merge({
                isResettingPsw: false,
            }),
    }),

    // 获取角色列表
    ...createAsyncActionHandler(USER_GET_ROLES, {
        init: (state: any) =>
            state.merge({
                isGettingRoles: true,
            }),
        succeeded: (state: any, action: Action.Sync) =>
            state.merge({
                isGettingRoles: false,
                roles: state.get('roles').merge(action.payload),
            }),
        failed: (state: any) =>
            state.merge({
                isGettingRoles: false,
            }),
    }),
};

export const user = initial;
export default (state = user, action: any = {}): any => {
    const fn = handlers[action.type];
    return fn ? fn(state, action) : state;
};
